function getCollaboratorsState(state) {
  return {
    collaboratorsInfo: state.collaboratorsInfo.collaborators,
    errorCollaborators: state.collaboratorsInfo.errorCollaborators,
    loadingCollaborators: state.collaboratorsInfo.loadingCollaborators,
    hasCollaboratorsInfo: state.collaboratorsInfo.hasCollaboratorsInfo,
    posting: state.collaboratorsInfo.posting,
    loadingPostingInfo: state.collaboratorsInfo.loadingPosting,
    postingError: state.collaboratorsInfo.postingError,
    updatingPermissions: state.collaboratorsInfo.updatingPermissions,
    updatedPermission: state.collaboratorsInfo.updatedPermission,
    errorUpdatePermission: state.collaboratorsInfo.errorUpdatePermission,
    currentUser: state.collaboratorsInfo.currentUser
  };
}

export { getCollaboratorsState };
